import { isLocalTrafficSource } from '../../shared/trafficOrigins.js';

export const OWNER_EXCLUSION_KEY = 'site_owner_excluded:v1';
export const GA_ID = 'G-WED90XV0C9';

export function isProductionVisit(location, embedded = false) {
  return !!location && !embedded && ['henryw.me', 'www.henryw.me'].includes(location.hostname)
    && !/[?&](embedded|showcase|captureStudy|galleryFrame|imageTrace)=/.test(`${location.search || ''}${location.hash || ''}`);
}

export function collectionAllowed() {
  if (typeof window === 'undefined' || !isProductionVisit(window.location, window.self !== window.top)) return false;
  if (typeof document !== 'undefined' && isLocalTrafficSource(document.referrer)) return false;
  try {
    return localStorage.getItem('askTelemetry') !== 'off'
      && localStorage.getItem(OWNER_EXCLUSION_KEY) !== '1'
      && !sessionStorage.getItem('shared_views_admin_session:v1');
  } catch { return true; }
}

export function excludeOwnerBrowser(excluded = true) {
  try { if (excluded) localStorage.setItem(OWNER_EXCLUSION_KEY, '1'); else localStorage.removeItem(OWNER_EXCLUSION_KEY); } catch { /* Storage is optional. */ }
  window[`ga-disable-${GA_ID}`] = !collectionAllowed();
  window.dispatchEvent(new Event('analytics-preference'));
}

export function publicPagePath(path) {
  const clean = String(path || '/').split('?')[0].split('#')[0];
  return clean.startsWith('/view/') ? '/view' : clean;
}
